export enum UserOrderBy {
  id = 'id',
  name = 'name'
}
